import { proposalsService } from '@/services/proposals';
import { useQuery } from '@tanstack/react-query';

export function useProposal(proposalId: string | undefined) {
  return useQuery({
    queryKey: ['proposal', proposalId],
    queryFn: async () => {
      if (!proposalId) {
        throw new Error('ProposalId é obrigatório');
      }

      const response = await proposalsService.getProposal(proposalId);
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar detalhes da proposta'
        );
      }

      return response.data;
    },
    enabled: !!proposalId,
    staleTime: 1000 * 60 * 5,
  });
}
